<template>
  <Button class="btn--act FormSubmit" splash type="submit"
          :disabled="_submitting || disabled">
    <CliLoader v-if="_submitting" :text="text" />
    <slot v-else />
  </Button>
</template>
<script>
import CliLoader from 'components/CliLoader';

export default {
  name: 'FormSubmit',
  inject: ['form'],

  computed: {
    _submitting () {
      return this.form !== undefined ? this.form.state.submitting : this.submitting;
    },
  },

  props: {
    text: { default: 'Submitting.. ', type: String },
    submitting: Boolean,
    disabled: Boolean,
  },

  components: { CliLoader },
};
</script>
